import type { QueryFunction, QueryKey } from '@tanstack/react-query';
import { request } from './httpClient';
import type { HttpRequest } from './types';

export type QueryDescriptor = string | (Pick<HttpRequest, 'path'> & Partial<HttpRequest>);

const toRequest = (desc: QueryDescriptor, signal: AbortSignal): HttpRequest =>
  typeof desc === 'string' ? { method: 'GET', path: desc, signal } : { method: 'GET', ...desc, signal };

export const queryFn =
  <T>(desc: QueryDescriptor): QueryFunction<T, QueryKey> =>
  ({ signal }) =>
    request<T>(toRequest(desc, signal));
